import React from 'react';
import { Calendar, User, ArrowRight } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { SEO } from '../components/SEO';

export const Journal = () => {
  const posts = [
    {
      id: 1,
      title: "5 Natural Herbs for boundless Energy",
      excerpt: "Discover the ancient roots that power modern vitality. From Ginseng to Maca, learn what works.",
      date: "Oct 12, 2025",
      author: "Dr. Simba",
      image: "https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&q=80&w=800",
      category: "Wellness"
    },
    {
      id: 2,
      title: "Understanding Male Vitality Cycles",
      excerpt: "How circadian rhythms and seasonal changes affect your performance and what you can do about it.",
      date: "Sep 28, 2025",
      author: "Wellness Team",
      image: "https://images.unsplash.com/photo-1517849845537-4d257902454a?auto=format&fit=crop&q=80&w=800",
      category: "Education"
    },
    {
      id: 3,
      title: "The Truth About Detox Programs",
      excerpt: "Why a natural cleanse is the first step to rebuilding your strength foundation.",
      date: "Sep 15, 2025",
      author: "Dr. Simba",
      image: "https://images.unsplash.com/photo-1512069772995-ec65ed456eb7?auto=format&fit=crop&q=80&w=800",
      category: "Detox"
    }
  ];

  const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://www.simbaherbals.com';
  const blogJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Blog',
    name: 'Wellness Insights – Simba Herbals UK',
    description: 'Expert advice, natural tips, and stories from the heart of Simba Herbals. Herbs for energy, male vitality, and the Mufasa Protocol.',
    url: `${SITE_URL}/journal`,
    publisher: { '@type': 'Organization', name: 'Simba Herbals UK', url: SITE_URL },
    blogPost: posts.map((post) => ({
      '@type': 'BlogPosting',
      headline: post.title,
      description: post.excerpt,
      datePublished: post.date,
      author: { '@type': 'Person', name: post.author },
      image: post.image,
    })),
  };

  return (
    <div className="pb-20">
      <SEO
        title="Wellness Insights"
        description="Expert advice, natural tips, and stories from the heart of Simba Herbals. Herbs for energy, male vitality, and the Mufasa Protocol."
        canonical="/journal"
        type="article"
        jsonLd={blogJsonLd}
      />
      <PageHero
        title="Wellness Insights"
        subtitle="Expert advice, natural tips, and stories from the heart of Simba Herbals."
        image="/images/services/Herbal Supplements.jpg"
        height="h-[100vh]"
      />

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {posts.map((post) => (
            <div key={post.id} className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-2xl mb-6 h-64">
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur text-xs font-bold px-3 py-1 rounded-full text-simba-dark uppercase tracking-wider z-10">
                  {post.category}
                </div>
                <img 
                  src={post.image} 
                  alt={post.title} 
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-in-out"
                />
              </div>
              
              <div className="flex items-center space-x-4 text-xs text-gray-500 mb-3 font-medium">
                <div className="flex items-center"><Calendar size={14} className="mr-1"/> {post.date}</div>
                <div className="flex items-center"><User size={14} className="mr-1"/> {post.author}</div>
              </div>

              <h2 className="font-display font-bold text-xl text-simba-dark mb-3 group-hover:text-simba-green transition-colors leading-tight">
                {post.title}
              </h2>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">
                {post.excerpt}
              </p>
              
              <span className="inline-flex items-center text-simba-gold font-bold text-sm group-hover:translate-x-1 transition-transform">
                Read Article <ArrowRight size={16} className="ml-2" />
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
